import _defineProperty2 from "D:\\Portal_repos\\VE_R2.9\\SWIFMod_CC_Portal_11_4_1\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty2(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = _Reflect$construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !_Reflect$construct) return false;
  if (_Reflect$construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Date.prototype.toString.call(_Reflect$construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { TranslatorContext } from '@jutro/locale';
import { intlMessageShape, tooltipBaseProps, deprecated, placementOptions } from '@jutro/prop-types';
import { ContextConsumer, getMessageProp } from '@jutro/platform';
import { TooltipContent } from './TooltipContent';
import styles from "./TooltipIcon.module.css";
import { Tooltip } from './Tooltip';
import { Icon } from '../Icon/Icon';
import { messages } from './TooltipIcon.messages';
export var TooltipIcon = function (_React$Component) {
  _inherits(TooltipIcon, _React$Component);
  var _super = _createSuper(TooltipIcon);
  function TooltipIcon(props) {
    var _this;
    _classCallCheck(this, TooltipIcon);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function (event) {
      if (_this.iconRef && _this.tooltip && !_this.tooltip.popper.contains(event.target) && !_this.iconRef.current.contains(event.target)) {
        _this.hideTooltip();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getOpenIcon", function (icon) {
      return "".concat(icon);
    });
    _defineProperty(_assertThisInitialized(_this), "getClosedIcon", function (icon) {
      return "".concat(icon, "-outline");
    });
    _defineProperty(_assertThisInitialized(_this), "setClosedIcon", function _callee() {
      return _regeneratorRuntime().async(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", _this.setState({
                icon: _this.getClosedIcon(_this.props.icon)
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, null, null, null, Promise);
    });
    _defineProperty(_assertThisInitialized(_this), "setOpenIcon", function _callee2() {
      return _regeneratorRuntime().async(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", _this.setState({
                icon: _this.getOpenIcon(_this.props.icon)
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, null, null, null, Promise);
    });
    _defineProperty(_assertThisInitialized(_this), "toggleTooltip", function (evt) {
      evt.preventDefault();
      var _assertThisInitialize = _assertThisInitialized(_this),
        tooltip = _assertThisInitialize.tooltip,
        setClosedIcon = _assertThisInitialize.setClosedIcon,
        setOpenIcon = _assertThisInitialize.setOpenIcon;
      if (tooltip) {
        if (tooltip.state.isVisible) {
          setClosedIcon().then(tooltip.hide);
        } else {
          setOpenIcon().then(tooltip.show);
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "hideTooltip", function () {
      var _assertThisInitialize2 = _assertThisInitialized(_this),
        tooltip = _assertThisInitialize2.tooltip,
        setClosedIcon = _assertThisInitialize2.setClosedIcon;
      if (tooltip !== null && tooltip !== void 0 && tooltip.state.isVisible) {
        setClosedIcon().then(tooltip.hide);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getAccessibilityProperties", function (translator) {
      var messageProps = _this.props.messageProps;
      var showTooltipLabel = getMessageProp('showTooltip', messageProps, messages);
      return {
        'aria-label': translator(showTooltipLabel),
        'aria-haspopup': 'true'
      };
    });
    _defineProperty(_assertThisInitialized(_this), "renderComponent", function (translator) {
      var _this$props = _this.props,
        id = _this$props.id,
        text = _this$props.text,
        title = _this$props.title,
        link = _this$props.link,
        href = _this$props.href,
        renderContent = _this$props.renderContent,
        className = _this$props.className,
        placementProp = _this$props.placement,
        tipPlacement = _this$props.tipPlacement,
        flipBehavior = _this$props.flipBehavior,
        labelPosition = _this$props.labelPosition,
        showInlineLabel = _this$props.showInlineLabel;
      var placement = tipPlacement || placementProp;
      var icon = _this.state.icon;
      var content = renderContent ? renderContent() : React.createElement(TooltipContent, {
        title: title,
        text: text,
        href: href,
        link: link,
        translator: translator
      });
      var tooltipProps = {
        id: id,
        content: content,
        placement: placement,
        trigger: 'manual',
        hideOnClick: false,
        flipBehavior: flipBehavior
      };
      var classes = cx(styles.tooltipIcon, _defineProperty2({}, styles[labelPosition], !showInlineLabel), className);
      return React.createElement(Tooltip, _extends({}, tooltipProps, {
        onCreate: function onCreate(tooltip) {
          _this.tooltip = tooltip;
        }
      }), React.createElement("button", _extends({
        ref: _this.iconRef,
        type: "button",
        onClick: _this.toggleTooltip,
        className: classes
      }, _this.getAccessibilityProperties(translator)), React.createElement(Icon, {
        icon: icon,
        "aria-hidden": "true"
      })));
    });
    _this.state = {
      icon: _this.getClosedIcon(props.icon)
    };
    _this.iconRef = React.createRef();
    return _this;
  }
  _createClass(TooltipIcon, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(ContextConsumer, {
        contexts: [TranslatorContext]
      }, this.renderComponent);
    }
  }]);
  return TooltipIcon;
}(React.Component);
_defineProperty(TooltipIcon, "propTypes", _objectSpread({
  id: PropTypes.string.isRequired,
  icon: PropTypes.string
}, tooltipBaseProps, {
  tipPlacement: deprecated(PropTypes.string, '6.0.0', 'Use placement instead.'),
  placement: PropTypes.oneOf(placementOptions),
  className: PropTypes.string,
  messageProps: PropTypes.shape({
    showTooltip: intlMessageShape
  }),
  flipBehavior: PropTypes.array,
  labelPosition: PropTypes.oneOf(['top', 'left']),
  showInlineLabel: PropTypes.bool
}));
_defineProperty(TooltipIcon, "defaultProps", {
  icon: 'mi-help'
});
TooltipIcon.__docgenInfo = {
  componentName: "TooltipIcon",
  packageName: "@jutro/components",
  description: "",
  displayName: "TooltipIcon",
  methods: [{
    name: "handleClickOutside",
    docblock: "Handles clicking outside\n@param {Event} event",
    modifiers: [],
    params: [{
      name: "event",
      description: null,
      type: {
        name: "Event"
      },
      optional: false
    }],
    returns: null,
    description: "Handles clicking outside"
  }, {
    name: "getOpenIcon",
    docblock: "getOpenIcon\n@param {string} icon\n@returns {string}",
    modifiers: [],
    params: [{
      name: "icon",
      description: null,
      type: {
        name: "string"
      },
      optional: false
    }],
    returns: {
      description: null,
      type: {
        name: "string"
      }
    },
    description: "getOpenIcon"
  }, {
    name: "getClosedIcon",
    docblock: "getClosedIcon\n@param {string} icon\n@returns {string}",
    modifiers: [],
    params: [{
      name: "icon",
      description: null,
      type: {
        name: "string"
      },
      optional: false
    }],
    returns: {
      description: null,
      type: {
        name: "string"
      }
    },
    description: "getClosedIcon"
  }, {
    name: "setClosedIcon",
    docblock: null,
    modifiers: ["async"],
    params: [],
    returns: null
  }, {
    name: "setOpenIcon",
    docblock: null,
    modifiers: ["async"],
    params: [],
    returns: null
  }, {
    name: "toggleTooltip",
    docblock: "toggleTooltip\n@param {Event} evt",
    modifiers: [],
    params: [{
      name: "evt",
      description: null,
      type: {
        name: "Event"
      },
      optional: false
    }],
    returns: null,
    description: "toggleTooltip"
  }, {
    name: "hideTooltip",
    docblock: null,
    modifiers: [],
    params: [],
    returns: null
  }, {
    name: "getAccessibilityProperties",
    docblock: "Returns accessibility properties for tooltip icon button\n\n@param {Function} translator function used to translate the message\n@returns {object} object containing accessibility properties",
    modifiers: [],
    params: [{
      name: "translator",
      description: "function used to translate the message",
      type: {
        name: "Function"
      },
      optional: false
    }],
    returns: {
      description: "object containing accessibility properties",
      type: {
        name: "object"
      }
    },
    description: "Returns accessibility properties for tooltip icon button"
  }, {
    name: "renderComponent",
    docblock: "Render tooltip icon\n\n@param {Function} translator function to translate strings\n@returns {React.ReactElement} tooltip icon",
    modifiers: [],
    params: [{
      name: "translator",
      description: "function to translate strings",
      type: {
        name: "Function"
      },
      optional: false
    }],
    returns: {
      description: "tooltip icon",
      type: {
        name: "React.ReactElement"
      }
    },
    description: "Render tooltip icon"
  }],
  actualName: "TooltipIcon",
  props: {
    id: {
      type: {
        name: "string"
      },
      required: true,
      description: "Used to identify the component. Referenced to find it in the document tree"
    },
    icon: {
      type: {
        name: "string"
      },
      required: false,
      description: "Icon to be displayed",
      defaultValue: {
        value: "'mi-help'",
        computed: false
      }
    },
    tipPlacement: {
      type: {
        name: "string"
      },
      required: false,
      description: "@deprecated Position of the tooltip in relation to icon",
      deprecationInfo: {
        version: "6.0.0",
        mapTo: null
      }
    },
    placement: {
      type: {
        name: "enum",
        computed: true,
        value: "placementOptions"
      },
      required: false,
      description: "Positions of the tooltip relative to its reference element (icon)"
    },
    className: {
      type: {
        name: "string"
      },
      required: false,
      description: "Additional class names for component."
    },
    messageProps: {
      type: {
        name: "shape",
        value: {
          showTooltip: {
            name: "union",
            required: false,
            value: [{
              name: "string"
            }, {
              name: "shape",
              value: {
                id: {
                  name: "string",
                  required: false
                },
                defaultMessage: {
                  name: "string",
                  required: false
                },
                args: {
                  name: "shape",
                  value: {},
                  required: false
                }
              }
            }]
          }
        }
      },
      required: false,
      description: "Message props(error message/aria-label)"
    },
    flipBehavior: {
      type: {
        name: "array"
      },
      required: false,
      description: "Determines the order of flipping of tooltip, i.e. which placements to prefer if a certain placement cannot be used"
    },
    labelPosition: {
      type: {
        name: "enum",
        value: [{
          value: "'top'",
          computed: false
        }, {
          value: "'left'",
          computed: false
        }]
      },
      required: false,
      description: "Information from Field Component to the Tooltip Icon about the whole label position"
    },
    showInlineLabel: {
      type: {
        name: "bool"
      },
      required: false,
      description: "Information from Field Component. If true, label is displayed inline"
    }
  },
  composes: ["@jutro/prop-types"]
};